export default {
      id: "pencil-simple-usage",
      viewBox: "2 2 16 16",
      url: __webpack_public_path__ + "img/icons.svg?fe1823f2d070fe6b8364c4176dd9a880#pencil-simple",
      toString: function () {
        return this.url;
      }
    }